export const GOOGLE_API_KEY = 'AIzaSyDT5Ko2uKsnkT0tp2txkftzMPwpWUDs6II';



// WEBPACK FOOTER //
// ./app/javascript/common/api_keys.js